import React from 'react';

import BlueprintNav from './BlueprintNav';
import { BLUEPRINT_DESCRIPTION, GEMINI_LOGO_URL } from './constants';
import { Section } from './types';

interface BlueprintHeroProps {
  sections: Section[];
}

const BlueprintHero = ({ sections }: BlueprintHeroProps) => {
  return (
    <div className="mx-auto max-w-[1256px] px-16 pb-24 pt-40 sm:px-24 sm:pt-56 lg:px-0 lg:pt-64">
      <h1 className="m-0 font-suisse-screen text-headline-alt-md text-black sm:text-headline-alt-lg">
        The Blueprint
      </h1>
      <div className="mt-16 flex flex-col gap-16 sm:gap-24">
        <p className="m-0 max-w-[809px] font-suisse-neue text-body-md text-black sm:text-body-lg">
          {BLUEPRINT_DESCRIPTION}
        </p>
        <div className="flex items-center gap-10">
          <span className="font-suisse-screen text-byline-sm text-black sm:text-byline-md">
            powered by
          </span>
          <img src={GEMINI_LOGO_URL} alt="Google Gemini" className="h-24" />
        </div>
        <BlueprintNav sections={sections} />
      </div>
    </div>
  );
};

export default BlueprintHero;
